require('data/moment/en-US');

window.__intlLocaleData = require('intl/locale-data/json/en-US');

window.__locale = {
  strings: require('/home/buildbotadmin/buildbot/drone/alphaRelease/build/.build/prod/build-1068/resources/locales/locale-data/strings/en'),
  templates: require('/home/buildbotadmin/buildbot/drone/alphaRelease/build/.build/prod/build-1068/resources/locales/locale-data/templates/en'),
  counting: require('/home/buildbotadmin/buildbot/drone/alphaRelease/build/.build/prod/build-1068/resources/locales/locale-data/counting/en'),
  social: require('/home/buildbotadmin/buildbot/drone/alphaRelease/build/.build/prod/build-1068/resources/locales/locale-data/social/en'),
  banners: require('/home/buildbotadmin/buildbot/drone/alphaRelease/build/.build/prod/build-1068/resources/locales/locale-data/banner'),
  actions: require('/home/buildbotadmin/buildbot/drone/alphaRelease/build/.build/prod/build-1068/resources/strings/actions/en'),
  billing: require('/home/buildbotadmin/buildbot/drone/alphaRelease/build/.build/prod/build-1068/resources/strings/billing/en'),
  exports: require('/home/buildbotadmin/buildbot/drone/alphaRelease/build/.build/prod/build-1068/resources/strings/exports/en'),
  labels: require('/home/buildbotadmin/buildbot/drone/alphaRelease/build/.build/prod/build-1068/resources/strings/labels/en'),
  notifications: require('/home/buildbotadmin/buildbot/drone/alphaRelease/build/.build/prod/build-1068/resources/strings/notifications/en'),
  notificationsGrouped: require('/home/buildbotadmin/buildbot/drone/alphaRelease/build/.build/prod/build-1068/resources/locales/locale-data/notificationsgrouped/en'),
  search: require('/home/buildbotadmin/buildbot/drone/alphaRelease/build/.build/prod/build-1068/resources/strings/search/en')
};


// WEBPACK FOOTER //
// ./tools/webpack/tmp/en-US.js